import { Image } from "@banuba/webar/dist/BanubaSDK.js"
import { getPlayer } from "./player"
import { GlassesEffect } from "."

const default_doc = {
  camera: {},
  faces: [{}],
  scene: "tint_admin_preview",
  version: "2.0.0",
}

export const reset = async () => {
  const _playerInstance = getPlayer()
  if (!_playerInstance) return

  const readyConfig = JSON.stringify(default_doc)
  try {
    //@ts-expect-error _effectManager is private
    await _playerInstance._effectManager.reloadConfig(readyConfig)
    GlassesEffect.resetGlasses()
  } catch (e) {
    console.error(e)
  }
}

export const applyImage = (image: string | Blob) => {
  const _playerInstance = getPlayer()

  if (!_playerInstance) return

  _playerInstance.use(new Image(image))
  _playerInstance.play({ pauseOnEmpty: false })
}

export const setMakeupState = async (
  region: string,
  finish: string,
  coverage: string,
  color: string
) => {
  const _playerInstance = getPlayer()
  if (!_playerInstance) return

  if (!region || !finish || !coverage || !color) return

  const makeupState = { ...default_doc }
  makeupState.faces = [
    {
      [region]: {
        finish,
        color,
        coverage,
      },
    },
  ]

  const readyConfig = JSON.stringify(makeupState)

  try {
    //@ts-expect-error _effectManager is private
    await _playerInstance._effectManager.reloadConfig(readyConfig)
  } catch (e) {
    console.error(e)
  }
}
